import { HTMLAttributes, useEffect, useState } from 'react'

import { formatArticle } from 'api/dataTransform'
import { PATHS } from 'api/paths'
import { callApi, getApiPath } from 'api/utils'
import { useIsMobile } from 'hooks/useIsMobile'
import { Article } from 'interfaces/types'

import { _Desktop } from './desktop'
import { _Mobile } from './mobile'

interface RelatedArticleCarouselProps extends HTMLAttributes<HTMLDivElement> {
  title?: string
  ids?: string
}
export interface RelatedArticlesProps extends RelatedArticleCarouselProps {
  articles: Array<Article>
}

export const RelatedArticleCarousel = ({
  ids,
  ...rest
}: RelatedArticleCarouselProps) => {
  const isMobile = useIsMobile()
  const [articles, setArticles] = useState<Array<Article>>([])
  useEffect(() => {
    ;(async () => {
      const idsArr = ids?.split(',') || []
      const _articles = await Promise.all(
        idsArr.map((id) =>
          callApi(
            getApiPath(PATHS.GET_ARTICLE_DETAIL, {
              slug: id,
              isRelated: 1,
            }),
            'get',
            undefined,
            true,
          ),
        ),
      ).then(
        (responses) =>
          responses
            ?.map((response) =>
              response.data?.post?.ID
                ? formatArticle(response.data?.post)
                : null,
            )
            .filter((a) => !!a) as Article[],
      )
      setArticles(_articles || [])
    })()
  }, [ids])

  if (isMobile) return <_Mobile articles={articles} {...rest} />
  return <_Desktop articles={articles} {...rest} />
}
